import React, { Component } from 'react';
// import IndicadorVendas from './IndicadorVendas';
import SalesGoalV2 from './SalesGoalV2';
import IsLoadingDiv from './IsLoadingDiv';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

class SalesGoalWrapper extends Component {
	render() {
		const { metaVendas, isLoadingSg } = this.props;

		const metaVendasFix = metaVendas && metaVendas.length > 0 ? metaVendas : [];

		if (!metaVendasFix.length || isLoadingSg) {
			return (
				<IsLoadingDiv isLoading={isLoadingSg}>
					<SalesGoalV2 />
				</IsLoadingDiv>
			);
		}

		const limitMetaVendas = metaVendasFix.slice(0, 5);

		return limitMetaVendas.map((metaVenda) =>
			metaVenda?.goal ? (
				<SalesGoalV2
					key={
						`${metaVenda?.supervisorId}.${metaVenda?.representativeId}.${metaVenda?.quotaArticle}` ??
						1
					}
					metaVenda={metaVenda}
				/>
			) : (
				<></>
			),
		);
	}
}

export default SalesGoalWrapper;
